"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var formatting_1 = require("lets-trade-utils/lib/utils/formatting");
function useRenderCellViews() {
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        var nowrapTextStyles = "text-nowrap text-small capitalize text-default-foreground";
        return [
            {
                key: "name",
                content: ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("b", { children: cellValue }) })),
            },
            {
                key: "surname",
                content: ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("b", { children: cellValue }) })),
            },
            {
                key: "email",
                content: (0, jsx_runtime_1.jsx)("div", { children: cellValue }),
            },
            {
                key: "unit_number",
                content: (0, jsx_runtime_1.jsx)("div", { children: cellValue }),
            },
            {
                key: "start_date",
                content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: (0, formatting_1.formatDateTime)(new Date(cellValue), "ccc, dd LLL yyyy") })),
            },
            {
                key: "end_date",
                content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: (0, formatting_1.formatDateTime)(new Date(cellValue), "ccc, dd LLL yyyy") })),
            },
            {
                key: "is_current_customer",
                content: ((0, jsx_runtime_1.jsx)(react_2.Chip, __assign({ className: "text-nowrap text-small capitalize text-default-foreground", size: "md", variant: "flat", color: cellValue === true ? "success" : cellValue === false ? "warning" : null }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: nowrapTextStyles }, { children: cellValue === true ? "Yes" : "No" })) }))),
            },
        ];
    }, [client]);
    return (0, react_1.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
exports.useRenderCellViews = useRenderCellViews;
